import { render, staticRenderFns } from "./UltimosAcessos.vue?vue&type=template&id=0b60cd0b"
import script from "./UltimosAcessos.vue?vue&type=script&lang=ts"
export * from "./UltimosAcessos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports